/**
 * Updates the URL query parameter with the new value.
 * If the value is omitted or empty, it will remove it.
 * If the result is an empty URL query parameter list, it will replace the state
 * @param key {string}
 * @param value {string}
 */
export const updateURLQueryParam = (key: string, value?: string) => {
  const params = new URLSearchParams(window.location.search);
  // Set the value if it exists and isn't an empty string
  if (value && value !== '') {
    params.set(key, value);
  } else {
    // Otherwise, remove it
    params.delete(key);
  }

  // If the result is an empty param list, replace the state with nothing
  if (Array.from(params.keys()).length === 0) {
    window.history.replaceState(null, '', window.location.pathname);
    return;
  }

  window.history.replaceState(null, '', `${window.location.pathname}?${params.toString()}`);
};
